import React, { useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'

import * as types from '../../redux/constantes/job'
import { ListJobsAction } from '../../redux/actions/job'

import { ContainerContentListInfo, ContainerTemplate } from '../../components/Containers'
import { FiltersSearch } from '../../components/FiltersSearch'
import { Header } from '../../components/Header'
import { Table } from '../../components/Table'
import { MessageBoxAlert, MessageBoxError } from '../../components/MessageBox'
import { TableItem } from '../../components/TableItem'
import { jobs } from '../../types/components/jobs'
import { Card } from '../../components/Card'
import { WrapperMobile } from '../../components/Wrapper'

export const TemplateListJobs: React.FC = () => {
  const [area, setArea] = useState<string>()
  const [place, setPlace] = useState<string>()
  const [office, setOffice] = useState<string>()
  const [modality, setModality] = useState<string>()

  const { listJobs, loading, error } = useSelector((state: RootStateOrAny) => state.listJobs)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(ListJobsAction())
  }, [])

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch({ type: types.LIST_JOBS_ERROR })
      }, 5000)
    }
  }, [error])

  const filteredJobsByArea = area
    ? listJobs &&
      listJobs.jobs.filter((job: jobs) => {
        return job.Area.toLowerCase().includes(area.toLowerCase())
      })
    : listJobs && listJobs.jobs

  const filteredJobsByPlace = place
    ? filteredJobsByArea &&
      filteredJobsByArea.filter((job: jobs) => {
        return job.Local.toLowerCase().includes(place.toLowerCase())
      })
    : filteredJobsByArea && filteredJobsByArea

  const filteredJobsByOffice = office
    ? filteredJobsByPlace &&
      filteredJobsByPlace.filter((job: jobs) => {
        return job.Cargo.toLowerCase().includes(office.toLowerCase())
      })
    : filteredJobsByPlace && filteredJobsByPlace

  const filteredJobsByModality = modality
    ? filteredJobsByOffice &&
      filteredJobsByOffice.filter((job: jobs) => {
        return job.Modalidade.toLowerCase().includes(modality.toLowerCase())
      })
    : filteredJobsByOffice && filteredJobsByOffice

  return (
    <ContainerTemplate>
      <Header text="Vagas de Emprego em aberto" />
      <ContainerContentListInfo>
        {error && <MessageBoxError>{error}</MessageBoxError>}
        {loading && <MessageBoxAlert>Carregando...</MessageBoxAlert>}
        <FiltersSearch
          typeFilter="user"
          jobsArray={listJobs && listJobs.jobs}
          area={area}
          setArea={setArea}
          place={place}
          setPlace={setPlace}
          office={office}
          setOffice={setOffice}
          modality={modality}
          setModality={setModality}
        />
        <Table>
          {filteredJobsByModality &&
            filteredJobsByModality
              .sort(function (a: jobs, b: jobs) {
                if (a.Cargo < b.Cargo) {
                  return -1
                } else {
                  return true
                }
              })
              .map((job: jobs, index: number) => {
                let result
                if (job.IsActive) {
                  result = <TableItem job={job} key={index} nameButton="Detalhes" pathButton="/detalhes-vaga" />
                }
                return result
              })}
        </Table>
        <WrapperMobile>
          {filteredJobsByModality &&
            filteredJobsByModality
              .sort(function (a: jobs, b: jobs) {
                if (a.Cargo < b.Cargo) {
                  return -1
                } else {
                  return true
                }
              })
              .map((job: jobs, index: number) => {
                let result
                if (job.IsActive) {
                  result = <Card job={job} key={index} nameButton="Detalhes" pathButton="/detalhes-vaga" />
                }
                return result
              })}
        </WrapperMobile>
      </ContainerContentListInfo>
    </ContainerTemplate>
  )
}
